import { render, staticRenderFns } from "./TechnicalParameters.vue?vue&type=template&id=13212275&scoped=true"
var script = {}
import style0 from "./TechnicalParameters.vue?vue&type=style&index=0&id=13212275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13212275",
  null
  
)

export default component.exports